import { InstantLoanStateType } from "../../../Reducers/types"

export const employmentDetailsParser = (
  state: InstantLoanStateType["employmentDetails"]
): Partial<Record<keyof InstantLoanStateType["employmentDetails"], any>> => ({
  ...state,
  employmentStatus: parseInt(state.employmentStatus || ""),
  jobAddressStateId: undefined,
  jobAddressLatitude: undefined,
  jobAddressLongitude: undefined,
  jobAddressCountryId: undefined,
  timeAtCurrentJob: parseInt(state.timeAtCurrentJob || ""),
  startClaimDate: undefined,
  endClaimDate: undefined,
  jobAddressPostalCode: undefined,
  jobAddressAptNumber: undefined,
  jobAddressAutocomplete: undefined,
  jobAddressCity: undefined,
  jobAddressCivicNumber: undefined,
  jobAddressStreet: undefined,
})
